import { render, staticRenderFns } from "./menuTemplate.vue?vue&type=template&id=893d0858&scoped=true&"
import script from "./menuTemplate.vue?vue&type=script&lang=js&"
export * from "./menuTemplate.vue?vue&type=script&lang=js&"
import style0 from "./menuTemplate.vue?vue&type=style&index=0&id=893d0858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893d0858",
  null
  
)

export default component.exports